module.exports = __webpack_public_path__ + "static/media/covi_ppe_no_hom.139a3a7d.png";